import React, { useEffect } from 'react';
import { Card, Row, Col, FormGroup } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { getMultiSubBrandDetails } from '../../../SystemMasters/Store/SystemMasters.action';

export function BasicLibraryDetail({
  libraryData,
  errorFields,
  handleBasicDetail,
  brandsOptions,
  productTypeOptions,
  supplierOptions,
  isSubBrandAccess,
  subBrandOptions,
}) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isEmpty(libraryData?.brandId)) {
      const queryParams = {
        brandId: libraryData?.brandId?.map((item) => item.value),
      };
      dispatch(getMultiSubBrandDetails(queryParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryData?.brandId]);

  // Filter selected sub-brands when sub-brand options change (after API call)
  useEffect(() => {
    if (subBrandOptions?.length > 0 && libraryData?.subBrandId?.length > 0 && isSubBrandAccess) {
      const availableSubBrandIds = subBrandOptions.map((option) => option._id);
      const filteredSelectedSubBrands = libraryData.subBrandId.filter((subBrand) => availableSubBrandIds.includes(subBrand._id || subBrand.value));

      if (filteredSelectedSubBrands?.length !== libraryData?.subBrandId?.length) {
        handleBasicDetail('subBrandId', filteredSelectedSubBrands);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subBrandOptions]);

  return (
    <Card className="card custom-card card-body basic-detail mb-2 pb-1">
      <Row>
        <Col md={3}>
          <div className="common-input-control">
            <p className="field-name">
              {t('CUSTOM_MODULE.NAME')} <span className="asterisk">*</span>
            </p>
            <input
              type="text"
              name="moduleName"
              // value={rightColumnData?.moduleName}
              value={libraryData?.moduleName}
              onChange={(e) => handleBasicDetail('moduleName', e.target.value)}
              placeholder={t('CUSTOM_MODULE.NAME')}
              className="form-control"
            />
            {errorFields?.includes('moduleName') && <p className="mb-0 error-message">{t('CUSTOM_MODULE.NAME_REQUIRED')}</p>}
          </div>
        </Col>
        <Col md={3}>
          <FormGroup>
            <div className="common-react-select">
              <p className="field-name">
                {t('CUSTOM_MODULE.BRAND')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                options={brandsOptions}
                className="custom-multiselect w-100"
                // value={rightColumnData?.brandId || []}
                value={libraryData?.brandId || []}
                labelledBy={t('CUSTOM_MODULE.SELECT_BRAND')}
                overrideStrings={{
                  selectSomeItems: t('CUSTOM_MODULE.SELECT_BRAND'),
                  search: t('CUSTOM_MODULE.SEARCH_BRAND'),
                }}
                ClearSelectedIcon={null}
                onChange={(selected) => {
                  handleBasicDetail('brandId', selected);
                }}
              />
              {errorFields?.includes('brandId') && <p className="mb-0 error-message">{t('CUSTOM_MODULE.BRAND_REQUIRED')}</p>}
            </div>
          </FormGroup>
        </Col>
        {isSubBrandAccess && (
          <Col md={3}>
            <div className="common-react-select mb-0">
              <p className="field-name">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND')}</p>
              <MultiSelect
                name="SubBrand"
                options={subBrandOptions?.filter((e) => e.isActive) || []}
                className="product-custom-multiselect common-new-multiselect"
                value={libraryData?.subBrandId || []}
                labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND_NOT_SELECTED')}
                onChange={(selected) => handleBasicDetail('subBrandId', selected)}
              />
            </div>
          </Col>
        )}
        <Col md={3}>
          <div className="common-react-select">
            <p className="field-name">
              {t('CUSTOM_MODULE.PRODUCT_TYPE')}
              <span className="asterisk">*</span>
            </p>
            <MultiSelect
              options={productTypeOptions}
              className="custom-multiselect w-100"
              value={libraryData?.productTypeId || []}
              labelledBy={t('CUSTOM_MODULE.SELECT_PRODUCT_TYPE')}
              overrideStrings={{
                selectSomeItems: t('CUSTOM_MODULE.SELECT_PRODUCT_TYPE'),
                search: t('CUSTOM_MODULE.SEARCH_PRODUCT_TYPE'),
              }}
              ClearSelectedIcon={null}
              onChange={(selected) => {
                handleBasicDetail('productTypeId', selected);
              }}
            />
            {errorFields?.includes('productTypeId') && <p className="mb-0 error-message">{t('CUSTOM_MODULE.PRODUCT_TYPE_REQUIRED')}</p>}
          </div>
        </Col>
        <Col md={3}>
          <FormGroup>
            <div className="common-react-select">
              <p className="field-name">
                {t('CUSTOM_MODULE.SUPPLIER')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                options={supplierOptions}
                className="custom-multiselect w-100"
                value={libraryData?.supplierId || []}
                labelledBy={t('CUSTOM_MODULE.SELECT_SUPPLIER')}
                overrideStrings={{
                  selectSomeItems: t('CUSTOM_MODULE.SELECT_SUPPLIER'),
                  search: t('CUSTOM_MODULE.SEARCH_SUPPLIER'),
                }}
                ClearSelectedIcon={null}
                onChange={(selected) => {
                  handleBasicDetail('supplierId', selected);
                }}
              />
              {errorFields?.includes('supplierId') && <p className="mb-0 error-message">{t('CUSTOM_MODULE.SUPPLIER_REQUIRED')}</p>}
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Card>
  );
}
export default BasicLibraryDetail;
